import 'intersection-observer';
import LDError from '@/services/errors'

import {
  CONF_REQ_PROPS,
  LANG
} from '@/constants';

import Vue from 'vue'
import config from '@/config'
// import './pollyfills'
// @ts-ignore
import store from './store'
import VueRouter from 'vue-router'
// import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
// @ts-ignore
import localeRu from 'element-ui/lib/locale/lang/ru-RU'
// @ts-ignore
import localeEn from 'element-ui/lib/locale/lang/en'
// @ts-ignore
import localeTr from 'element-ui/lib/locale/lang/tr-TR'
// @ts-ignore
import localeKz from '@/lang/kz/locale'
// @ts-ignore
import localeCn from 'element-ui/lib/locale/lang/zh-CN'
// @ts-ignore
import localeUz from '@/lang/uz/locale';
// @ts-ignore
import localeIn from '@/lang/in/locale';
// @ts-ignore
import localeEs from 'element-ui/lib/locale/lang/es'
// @ts-ignore
import App from './App.vue'
// @ts-ignore
import bus from './services/bus'
// @ts-ignore

// Plugins
// @ts-ignore
import GlobalComponents from './gloablComponents'
// @ts-ignore
import GlobalDirectives from './globalDirectives'
// @ts-ignore
import GlobalFilters from './globalFilters'
// @ts-ignore
import SideBar from './components/SidebarPlugin'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// @ts-ignore
import IdleVue from 'idle-vue'
// @ts-ignore
import VueClipboard from 'vue-clipboard2'
// @ts-ignore
import VueTruncate from 'vue-truncate-filter'
// @ts-ignore
import YmapPlugin from 'vue-yandex-maps'
// @ts-ignore
import Sticky from 'vue-sticky-directive'
import moment from 'moment'
// @ts-ignore
import vueMoment from 'vue-moment'
import 'moment/locale/ru'
import 'moment/locale/en-gb'
import 'moment/locale/tr'
import 'moment/locale/kk'
import 'moment/locale/zh-cn'
import 'moment/locale/uz-latn'
import 'moment/locale/pa-in'
import 'moment/locale/es'

// router setup
import router from './routes'

// @ts-ignore
import sidebarLinks from './sidebarLinks'
// @ts-ignore
import localStorageTransport from './services/localStorageTransport'

import VueObserveVisibility from 'vue-observe-visibility'

import {routerHistory} from '@/plugins/router-history'
import './plugins/resizeDetector'
// @ts-ignore
import tabsSidebar from 'src/plugins/tabs-sidebar'
import capitalizer from 'src/plugins/capitalizer'
import declin from 'src/plugins/declin'
// @ts-ignore
import VDragged from 'v-dragged'
// @ts-ignore
// import vOutsideEvents from 'vue-outside-events'

import { Plugin } from 'vue-fragment';

import {getCheckedLang, getLang, setLang, LANG_KEY} from '@/services/langStorage'

import VueI18n from 'vue-i18n';
import i18nEn from '@/lang/en/index';
import i18nRu from '@/lang/ru/index';
import i18nTr from '@/lang/tr/index';
import i18nUz from '@/lang/uz/index';
import i18nKz from '@/lang/kz/index';
import i18nCn from '@/lang/cn/index';
import i18nIn from '@/lang/in/index';
import i18nEs from '@/lang/es/index';
import VueMeta from 'vue-meta';

async function logExternal(data: any) {
  try {
    store.dispatch('logExternal', data)
  } catch (error) {
    console.log('LOG: name -> error', error)
  }
}

function appInit() {
  Vue.use(Plugin);
  Vue.use(VueMeta);

  Vue.use(capitalizer)
  Vue.use(declin)
  Vue.use(VDragged)
  Vue.use(VueObserveVisibility)
  Vue.use(vueMoment, {moment})
  // Vue sticky
  Vue.use(Sticky)
  Vue.directive('sticky', Sticky)

  Vue.use(localStorageTransport)

  const Lang = getCheckedLang() || config(LANG) || 'en';
  let locale;

  if (Lang === 'ru') {
    locale = localeRu;
  } else if (Lang === 'tr') {
    locale = localeTr;
  } else if (Lang === 'kz') {
    locale = localeKz;
  } else if (Lang === 'cn') {
    locale = localeCn;
  } else if (Lang === 'uz') {
    locale = localeUz;
  } else if (Lang === 'es') {
    locale = localeEs;
  } else if (Lang === 'in') {
    locale = localeIn;
  } else {
    locale = localeEn;
  }

  // plugin setup
  Vue.use(VueI18n)
  Vue.use(tabsSidebar)
  Vue.use(VueRouter)
  Vue.use(routerHistory)
  Vue.use(ElementUI, {locale})
  Vue.use(GlobalDirectives)
  Vue.use(GlobalComponents)
  Vue.use(GlobalFilters)
  // Vue.use(vOutsideEvents)
  // Vue.use(VueNotify)
  Vue.use(SideBar, {sidebarLinks})
  Vue.use(VeeValidate, {
    validity: false
  })

  if (process.env.NODE_ENV === 'production') {
    Vue.config.errorHandler = function(err, vm, info) {
      const data = LDError(err, 'JSError', {info})
      const error = {
        level: 'WARN',
        message: `WEB-UI ERROR: ${data.error.message}`,
        data: {ui_app: 'WEB-UI', ...data.ctx}
      }
      console.log('LOG: Vue.config.errorHandler -> error', error)
      logExternal(error);
    }

    window.onerror = function(message, source, line, column, error) {
      const data = LDError(error, 'JSError')
    }
  }

  const events = ['mousemove', 'keydown', 'mousedown', 'touchstart']
  Vue.use(IdleVue, {
    eventEmitter: new Vue(),
    idleTime: 9999999999999999,
    events: events.concat(['keepalive'])
  })

  // @ts-ignore
  localStorageTransport.on('keepalive', (time) => {
    // @ts-ignore
    window.dispatchEvent(new CustomEvent('keepalive', {time}))
  })
  events.forEach((event) => {
    window.addEventListener(event, () => {
      localStorageTransport.emit('keepalive', (new Date()).getTime())
    })
  })

  Vue.use(VueClipboard)
  Vue.use(VueTruncate)
  Vue.use(YmapPlugin)
  // locale.use(lang)

  Vue.prototype.$bus = bus

  const messages = {
    en: {...i18nEn},
    ru: {...i18nRu},
    tr: {...i18nTr},
    kz: {...i18nKz},
    cn: {...i18nCn},
    uz: {...i18nUz},
    in: {...i18nIn},
    es: {...i18nEs}
  }

  Vue.prototype.$msgs = messages

  const i18n = new VueI18n({
    locale: Lang,
    // @ts-ignore
    messages
  })

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    render: h => h(App),
    router,
    i18n,
    store
  })
}

(async function () {
  try {
    let response = await fetch('/config.json');
    let config = await response.json();
    for (const prop of CONF_REQ_PROPS) {
      if (!config[prop]) {
        alert(`appConfig property: "${prop}" not found!`)
        console.error(`appConfig property: "${prop}" not found!`, {appConfig: config})
        window.stop();
        break;
      }
    }
    window.appConfig = config;

    if (!getLang(LANG_KEY)) {
      const defaultLang = config[LANG] || 'en';
      setLang(LANG_KEY, defaultLang);
    }

    Object.freeze(window.appConfig);
    appInit();
  } catch (error) {
    alert('appConfig not found!')
    console.error('appConfig not found!', error)
    window.stop();
  }
})();